import type { ReactNode } from 'react';

/** The AB Test branch variations. */
export enum Variation {
  A = 'T_A',
  IGNORE = 'T_AN',
  B = 'T_B',
  C = 'T_C',
  D = 'T_D',
}

/** The AB Test Variation Keys. */
export type VariationKeys = 'T_A' | 'T_AN' | 'T_B' | 'T_C' | 'T_D';

/** The API AB Test Variation Keys. */
export type VariationKeysKebabCase = 'T-A' | 'T-AN' | 'T-B' | 'T-C' | 'T-D';

/** The available AB Test triggers. */
export type Triggers = 'load' | 'click' | 'delay' | 'redirect' | 'submit' | 'scroll' | 'visible';

/** The AB Test context props. */
export interface ContextProps {
  /** The branch the AB Test should be using. */
  branch: string | null;
  /** The trigger that enables the AB Test. */
  trigger: Triggers;
  /** Checks if the trigger has fired for the AB Test. */
  hasTriggerFired: boolean;
  /** The selector used in the AB Test. */
  selector?: string;
  /** A function that triggers the AB Test. */
  triggerCurrentTest: () => void;
  /** Determines if the AB Test shield should be displayed. */
  shouldShowShield?: boolean;
  /**  Explicitly define the branches you'll be using to avoid discrepancies with feature flag variation allocations */
  branchesToRender: Variation[];
}

/** The Props for the AB Test Branch */
export interface BranchProps {
  /** Sets the HTML tag for the AB Test Branch component. */
  as?: 'div' | 'span' | 'ul' | 'section';
  /** Defines a variation of the AB Test */
  branch: Variation;
  /** The children of the AB Test Branch */
  children: ReactNode;
  /** Allows the component to get additional styles */
  className?: string;
}
